import React, { ReactNode } from 'react'

import { on } from 'events'

import { RegisterOptions } from 'react-hook-form/dist/types/validator'

import { FormControl, FormControlLabel, FormHelperText, Checkbox as MuiCheckBox, Stack, Typography, useTheme } from '@mui/material'

import type { FieldValues } from 'react-hook-form'

import { FieldProps } from './types'






interface CheckboxFieldProps<T extends FieldValues = FieldValues>
  extends Omit<FieldProps<T>, 'startAdornment'> {
  name: string
  label?: string
  defaultValue?: string
  helperText?: string
  labelAdornment?: ReactNode
  rules?: RegisterOptions
  readOnly?: boolean
  sx?: object
  onChange?: () => void
  checked?: boolean
}

const CheckboxFieldImpl = ({
  label,
  name,
  rules,
  register,
  helperText,
  // formState: { errors },
  readOnly = false,
  defaultValue = '',
  sx,
  onChange,
  checked,
}: CheckboxFieldProps) => {

  const theme = useTheme()

  const vera_theme ={
    borderRadius: 2,
    border: `1px solid  ${theme.palette.primary[50]}`,
    fontSize: 16,
    "input": {
      padding: 3,
    },
    "&:hover": {
      border: `1px solid ${theme.palette.brand[600]}` // Change border color when input is hovered
    }
  }

  return (
    <FormControl 
    // error={!!errors[name]} 
    fullWidth>
      <FormControlLabel
        sx={{
          // Flush-left: the checkbox square lines up with the form fields above
          // (no default FormControlLabel indent).
          ml: 0,
          '& .MuiFormControlLabel-label': {
              fontSize: 14
          }
        }}
        control={
        <MuiCheckBox
          checked={checked}
          onChange={onChange}
          sx={{
            p: 0,
            mr: 2,
            // VRG-474 — no `color` here; see the same note in @repo/ui's CheckBox. This
            // pinned both states to `grey[900]` and overrode the shared MuiCheckbox theme,
            // so this field was heavier than every other checkbox in the app and immune to
            // a central fix. Colour lives in `packages/ui/theme/theme.ts`.
          }}
        />
      } label={label} />
    </FormControl>
  )
}

/**
 * Re-exported under the generic signature so a caller's own form type flows through.
 * See the `FieldProps` docblock in `./types` for why the implementation above stays on the
 * default instantiation and why this assertion is the standard idiom rather than a
 * suppression.
 */
export const CheckboxField = CheckboxFieldImpl as <T extends FieldValues = FieldValues>(
  props: CheckboxFieldProps<T>,
) => React.ReactElement | null
